import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import store from '../../../store';
import { LoadingLion } from './LoadingLion';
import { useAssignTest, useMount } from '../../../hooks';
import nonCriticalException from '../../../modules/exceptionLogger';
import { LANDING_REDESIGN_2024_FLAG, LANDING_REDESIGN_2024_PERCENT } from '../homepage/HomePage';

export const LoadingLionContainer: React.FCWithChildren = () => {
  const loading = useSelector(store.select.loader.loading);

  const assignLandingRedesign2024Test = useAssignTest(
    LANDING_REDESIGN_2024_FLAG,
    LANDING_REDESIGN_2024_PERCENT,
  );

  // Catches any test assignment errors, so it doesn't interrupt loading landing page, in case
  const safelyAssignLandingRedesign2024Test = useCallback(async () => {
    try {
      await assignLandingRedesign2024Test();
    } catch (e) {
      nonCriticalException(e);
    }
  }, [assignLandingRedesign2024Test]);

  useMount(async () => {
    await safelyAssignLandingRedesign2024Test();
  });

  if (!loading) {
    return null;
  }

  return (
    <LoadingLion />
  );
};
